import { computed, makeObservable, observable, runInAction } from 'mobx';

import { inject, injectable } from '@servicetitan/react-ioc';
import { StandaloneRootStore } from '@servicetitan/standalone-root';

import { LoadStatus } from '../enums/load-status';
import { loadFullStorySnippetAndIdentify } from '../utils/fullstory-configuration';
import { routeConfiguration } from '../enums/routes';

@injectable()
export class AppStore {
    @observable loadStatus = LoadStatus.None;

    constructor(@inject(StandaloneRootStore) private standaloneRootStore: StandaloneRootStore) {
        makeObservable(this);
        this.init();
    }

    @computed get defaultMFEData() {
        return {
            ...this.standaloneRootStore.defaultMFEData,
            routeConfiguration,
            isStandalone: true,
        };
    }

    init = () => {
        try {
            loadFullStorySnippetAndIdentify(
                this.standaloneRootStore.user.name,
                this.standaloneRootStore.tenant,
            );

            runInAction(() => {
                this.loadStatus = LoadStatus.Ok;
            });
        } catch {
            runInAction(() => (this.loadStatus = LoadStatus.Error));
        }
    };

    get isLoading() {
        return this.loadStatus !== LoadStatus.Ok;
    }
}
